import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.props.varios)
      ? (_openBlock(), _createBlock(_component_a_select, {
          key: 0,
          ref: "refSelecionarPais",
          class: "ss-tamanho-completo",
          value: _ctx.computedCodigosSelecionados,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedCodigosSelecionados) = $event)),
          "show-search": "",
          mode: "multiple",
          allowClear: _ctx.props.limparSelecao,
          placeholder: _ctx.props.placeholder,
          optionFilterProp: "label",
          filterOption: false,
          "not-found-content": _ctx.state.buscandoDados ? undefined : null,
          options: _ctx.state.listaPais,
          disabled: _ctx.props.disabled,
          onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.pesquisarPais(''))),
          onChange: _ctx.change,
          onSearch: _cache[2] || (_cache[2] = ($event: any) => (_ctx.pesquisarPais($event))),
          onBlur: _ctx.blur
        }, _createSlots({ _: 2 }, [
          (_ctx.state.buscandoDados)
            ? {
                name: "notFoundContent",
                fn: _withCtx(() => [
                  _createTextVNode(" Buscando País "),
                  _createVNode(_component_a_spin)
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["value", "allowClear", "placeholder", "not-found-content", "options", "disabled", "onChange", "onBlur"]))
      : (_openBlock(), _createBlock(_component_a_select, {
          key: 1,
          ref: "refSelecionarPais",
          class: "ss-tamanho-completo",
          value: _ctx.computedCodigoSelecionado,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.computedCodigoSelecionado) = $event)),
          "show-search": "",
          allowClear: _ctx.props.limparSelecao,
          placeholder: _ctx.props.placeholder,
          optionFilterProp: "label",
          filterOption: false,
          "not-found-content": _ctx.state.buscandoDados ? undefined : null,
          options: _ctx.state.listaPais,
          disabled: _ctx.props.disabled,
          onFocus: _cache[4] || (_cache[4] = ($event: any) => (_ctx.pesquisarPais(''))),
          onChange: _ctx.change,
          onSearch: _cache[5] || (_cache[5] = ($event: any) => (_ctx.pesquisarPais($event))),
          onBlur: _ctx.blur
        }, _createSlots({ _: 2 }, [
          (_ctx.state.buscandoDados)
            ? {
                name: "notFoundContent",
                fn: _withCtx(() => [
                  _createTextVNode(" Buscando País "),
                  _createVNode(_component_a_spin)
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["value", "allowClear", "placeholder", "not-found-content", "options", "disabled", "onChange", "onBlur"]))
  ]))
}